import { types } from "../../types/types";
import { MENU_RECLAMOS, RECLAMOS_ESTADOS, STEPPER_RECLAMOS_FORM } from "../../utils/constants";



const initialState = {
  items: [],
  itemsEfector: [],
  dataAfiliado: [],
  dataEfector: [],
  dataExternos: [],
  tipoReclamo: [],
  recepcionMenu: [],
  tipoOrigen: [],
  origenErrorReclamo: [],
  tipoComentarios: [],
  listaTipoReclamos: [],
  listaTipoOrigenes: [],
  listaCategoriasReclamos: [],
  categoriaReclamo: [],
  reclamoTomado: "",
  reclamo: [],
  reclamos: [],
  trackingReclamos: [],
  solicitudSeleccionada: null,
  solicitudesContadores: [],
  comentarios: [],
  efectorReclamo: [],
  documentacion: [],
  reclamosTomados: [],
  reclamosTomadosUsuario: [],

  estadoSolicitudes: RECLAMOS_ESTADOS.PENDIENTE?.toString(),
  activeBreadcrumb: MENU_RECLAMOS.DESELECCIONAR,
  activeStep: STEPPER_RECLAMOS_FORM.RECLAMOS_INGRESO,
  loading: false,
};

export const reclamosReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.setActiveBreadcrumbReclamo:
      return {
        ...state,
        activeBreadcrumb: action.payload,
      };
    case types.recepcionReclamoSetMenu:
      return {
        ...state,
        recepcionMenu: action.payload,
      };
    case types.reclamosSetDataAfiliado:
      return {
        ...state,
        dataAfiliado: action.payload,
      };
    case types.reclamosSetDataEfector:
      return {
        ...state,
        dataEfector: action.payload,
      };
    case types.reclamosSetDataExternos:
      return {
        ...state,
        dataExternos: action.payload,
      };
    case types.reclamosAfiliadoLimpiarSeleccion:
      return {
        ...state,
        dataAfiliado: [],
      };
    case types.reclamosEfectorLimpiarSeleccion:
      return {
        ...state,
        dataEfector: [],
      };
    case types.reclamosExternosLimpiarSeleccion:
      return {
        ...state,
        dataExternos: [],
      };
    case types.reclamosSetTipoReclamo:
      return {
        ...state,
        tipoReclamo: action.payload,
      };
    case types.reclamosSetTipoOrigen:
      return {
        ...state,
        tipoOrigen: action.payload,
      };
    case types.reclamosSetStep:
      return {
        ...state,
        activeStep: action.payload,
      };
    case types.listaTipoReclamosSuccess:
      return {
        ...state,
        listaTipoReclamos: action.payload,
      };
    case types.listaTipoOrigenesSuccess:
      return {
        ...state,
        listaTipoOrigenes: action.payload,
      };
    case types.listaCategoriasReclamosSuccess:
      return {
        ...state,
        listaCategoriasReclamos: action.payload,
      };
    case types.tomarReclamoIngresado:
      return {
        ...state,
        reclamoTomado: action.payload,
      };
    case types.traerReclamoPorIdEfector:
      return {
        ...state,
        reclamos: action.payload,
      };
    case types.traerReclamoPorId:
      return {
        ...state,
        reclamo: action.payload,
      };
    case types.traerReclamoPorIdAfiliado:
      return {
        ...state,
        reclamos: action.payload,
      };
    case types.traerReclamoPorCuit:
      return {
        ...state,
        reclamos: action.payload,
      };
    case types.traerReclamosEnviados:
      return {
        ...state,
        reclamos: action.payload,
      };
    case types.cleanReclamosEnviados:
      return {
        ...state,
        reclamos: [],
      };
    case types.reclamosUpdateEstadoSolicitudes:
      return {
        ...state,
        estadoSolicitudes: action.payload,
      };
    case types.trackingReclamos:
      return {
        ...state,
        trackingReclamos: action.payload,
      };
    case types.traerReclamosTodos:
      return {
        ...state,
        items: action.payload,
      };
    case types.traerReclamosEfectoresTodos:
      return {
        ...state,
        itemsEfector: action.payload,
      };
    case types.traerReclamosExternosTodos:
      return {
        ...state,
        itemsEfector: action.payload,
      };
    case types.reclamosGetContadoresSolicitudesSuccess:
      return {
        ...state,
        solicitudesContadores: action.payload,
      };
    //SOLICITUD SELECCIONADA
    case types.reclamosSetSolicitudSeleccionada:
      return {
        ...state,
        solicitudSeleccionada: action.payload,
      };
    case types.reclamosGetComentariosSolicitudesSuccess:
      return {
        ...state,
        comentarios: action.payload,
      };
    case types.newTipoReclamo:
      return {
        ...state,
        listaTipoReclamos: [...state.listaTipoReclamos, action.payload]
      }
    case types.putTipoReclamo:
      return {
        ...state,
        listaTipoReclamos: state.listaTipoReclamos.map(tipoReclamo => (
          tipoReclamo.id === action.payload.id
            ? action.payload : tipoReclamo
        ))
      };
    case types.removeTipoReclamo:
      return {
        ...state,
        listaTipoReclamos: state.listaTipoReclamos.filter((item) => { return item.id !== action.payload })
      };
    case types.newOrigenReclamo:
      return {
        ...state,
        listaTipoOrigenes: [...state.listaTipoOrigenes, action.payload]
      }
    case types.putOrigenReclamo:
      return {
        ...state,
        listaTipoOrigenes: state.listaTipoOrigenes.map(origenReclamo => (
          origenReclamo.id === action.payload.id
            ? action.payload : origenReclamo
        ))
      };
    case types.removeOrigenReclamo:
      return {
        ...state,
        listaTipoOrigenes: state.listaTipoOrigenes.filter((item) => { return item.id !== action.payload })
      };
    case types.newCategoriaReclamo:
      return {
        ...state,
        listaCategoriasReclamos: [...state.listaCategoriasReclamos, action.payload]
      }
    case types.putCategoriaReclamo:
      return {
        ...state,
        listaCategoriasReclamos: state.listaCategoriasReclamos.map(categoriaReclamo => (
          categoriaReclamo.id === action.payload.id
            ? action.payload : categoriaReclamo
        ))
      };
    case types.removeCategoriaReclamo:
      return {
        ...state,
        listaCategoriasReclamos: state.listaCategoriasReclamos.filter((item) => { return item.id !== action.payload })
      };
    case types.traerEfectorReclamo:
      return {
        ...state,
        efectorReclamo: action.payload
      };
    case types.documentacionReclamosClean:
      return {
        ...state,
        documentacion: [],
      };
    case types.documentacionReclamosSucces:
      return {
        ...state,
        documentacion: action.payload,
      }
    case types.documentacionReclamosInsert:
      return {
        ...state,
        documentacion: [
          ...state.documentacion,
          action.payload
        ],
      }
    case types.documentacionReclamosEliminar:
      return {
        ...state,
        documentacion: state.documentacion.filter(item => item.idDocumentacionReclamo !== action.payload)
      }
    case types.documentacionReclamosError:
      return {
        ...state,
        documentacion: [],
      };
    case types.traertipoComentarioReclamos:
      return {
        ...state,
        tipoComentarios: action.payload,
      };
    case types.listaOrigenErrorReclamoSuccess:
      return {
        ...state,
        origenErrorReclamo: action.payload,
      };
    case types.documentacionReclamosEfectorClean:
      return {
        ...state,
        documentacion: [],
      };
    case types.documentacionReclamosEfectorSucces:
      return {
        ...state,
        documentacion: action.payload,
      }
    case types.documentacionReclamosEfectorInsert:
      return {
        ...state,
        documentacion: [
          ...state.documentacion,
          action.payload
        ],
      }
    case types.documentacionReclamosEfectorEliminar:
      return {
        ...state,
        documentacion: state.documentacion.filter(item => item.idDocumentacionReclamo !== action.payload)
      }
    case types.documentacionReclamosEfectorError:
      return {
        ...state,
        documentacion: [],
      };
    //DOCUMENTACIONEXTERNOS
    case types.documentacionReclamosExternoClean:
      return {
        ...state,
        documentacion: [],
      };
    case types.documentacionReclamosExternoSucces:
      return {
        ...state,
        documentacion: action.payload,
      }
    case types.documentacionReclamosExternoInsert:
      return {
        ...state,
        documentacion: [
          ...state.documentacion,
          action.payload
        ],
      }
    case types.documentacionReclamosExternoEliminar:
      return {
        ...state,
        documentacion: state.documentacion.filter(item => item.idDocumentacionReclamo !== action.payload)
      }
    case types.documentacionReclamosExternoError:
      return {
        ...state,
        documentacion: [],
      };

    //RECLAMOS TOMADOS  
    case types.reclamosTomadosUsuarioSuccess:
      return {
        ...state,
        reclamosTomadosUsuario: action.payload,
      };
    case types.reclamosTomadosUsuarioLiberar:
      return {
        ...state,
        reclamosTomadosUsuario: state.reclamosTomadosUsuario.filter(
          (item) => item.id !== action.payload
        ),
      };
    case types.reclamosTomadosUsuarioAgregar:
      return {
        ...state,
        solicitudesTomadasUsuario: [
          ...state.reclamosTomadosUsuario,
          action.payload,
        ],
      };
    case types.reclamosTomadosUsuarioError:
      return {
        ...state,
        reclamosTomadosUsuario: [],
      };
    case types.reclamosTomadosSuccess:
      return {
        ...state,
        reclamosTomados: action.payload,
      };
    case types.reclamosTomadosLiberar:
      return {
        ...state,
        reclamosTomados: state.reclamosTomados.filter(
          (item) => item.id !== action.payload
        ),
      };
    case types.reclamosTomadosError:
      return {
        ...state,
        reclamosTomados: [],
      };
    case types.reclamosTomadosLimpiar:
      return {
        ...state,
        reclamosTomados: [],
        reclamosTomadosUsuario: [],
      };
    case types.reclamosTomadosLiberarTomadoPorIdReclamo:
      return {
        ...state,
        items: state.items.map((item) =>
          item.id === action.payload
            ? {
              ...item,
              idUsarioTomado: null,
              descripcionUsuarioTomado: null
            }
            : item
        ),
      };
    case types.reclamosMarcarTomado:
      return {
        ...state,
        items: state.items.map((item) =>
          item.id === action.payload.reclamo.id
            ? {
              ...item,
              descripcionUsuarioTomado: action.payload.auth.userName,
              idUsuarioTomado: action.payload.auth.idUsuario
            }
            : item
        ),
      };
    default:
      return state;
  }
}




